module.exports = __webpack_public_path__ + "6f3a3f18e1a255c0f56531173faa2c99.svg";